import { Checkbox } from "antd";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setValuesMultipleSelectOrderFrom } from "../../../store/reducer/globalMultipleSelect.reducer";
import { setGlobalErrors } from "../../../store/reducer/globalErrors.reducers";

const MultipleSelectOrderFrom = ({
  children,
  togglerClassName,
  placeholder,
  className,
  ...attrs
}) => {
  const dispatch = useDispatch();

  const { globalErrors } = useSelector((state) => state.globalErrors);

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [totalData, setTotalData] = useState(5);
  const [listSelected, setListSelected] = useState([]);
  const [isSelectedAll, setIsSelectedAll] = useState(false);

  const listData = useMemo(() => {
    const list = [
      { id: "Grolog", name: "GroLog" },
      { id: "Gromart", name: "GroMart" },
    ];
    return list;
  }, []);

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const isCheckedSelectAll = useMemo(() => {
    if (listSelected !== undefined && listSelected.length === totalData) {
      setIsSelectedAll(true);
      return true;
    }
    setIsSelectedAll(false);
    return false;
  }, [listSelected, totalData]);

  const isCheckedPerItem = useCallback(
    (item) => {
      if (listSelected.length > 0) {
        if (listSelected.length === totalData || listSelected.includes(-1)) {
          return true;
        }
        const isExist = listSelected.some((el) => el.id === item.id);
        return isExist;
      }
      return false;
    },
    [listSelected, totalData]
  );

  const isAllDepot = useMemo(() => {
    if (listSelected.length) {
      if (listSelected.includes(-1)) {
        return true;
      }
      const length = listSelected.length;
      if (listSelected.length > 0 && length === totalData) {
        return true;
      }
    }
    return false;
  }, [listSelected, totalData]);

  const handleClickSelectData = useCallback(
    (item) => {
      const errors = { ...globalErrors };
      if (errors?.order_from) {
        delete errors.order_from;
        dispatch(setGlobalErrors(errors));
      }
      if (item?.id === -1) {
        if (listSelected.length === 0 || !listSelected) {
          setListSelected([-1]);
          dispatch(setValuesMultipleSelectOrderFrom([-1]));
          return;
        }
        if (listSelected.length && listSelected.length - 1 !== totalData) {
          if (listSelected.includes(-1)) {
            setListSelected([]);
            dispatch(setValuesMultipleSelectOrderFrom([]));
            return;
          }
          setListSelected([-1]);
          dispatch(setValuesMultipleSelectOrderFrom([-1]));
          return;
        }
        if (listSelected.length && listSelected.includes(-1)) {
          setListSelected([]);
          dispatch(setValuesMultipleSelectOrderFrom([]));
        }

        return;
      }
      if (item?.id !== -1) {
        if (listSelected.length === 0) {
          const listDataSelected = listSelected;
          listDataSelected.push(item);
          setListSelected([...listDataSelected]);
          dispatch(setValuesMultipleSelectOrderFrom([...listDataSelected]));
          return;
        }
        const isAllSelected = listSelected.includes(-1);

        if (isAllSelected) {
          const idFiltering = [-1];
          idFiltering.push(item?.id);
          const newList = listData.filter(
            (el) => !idFiltering.includes(el?.id)
          );
          setListSelected([...newList]);
          dispatch(setValuesMultipleSelectOrderFrom([...newList]));
          return;
        }
        const isExist = listSelected.some((el) => el?.id === item?.id);
        if (isExist) {
          const listDataFiltered = listSelected.filter(
            (el) => el?.id !== item?.id
          );
          setListSelected([...listDataFiltered]);
          dispatch(setValuesMultipleSelectOrderFrom([...listDataFiltered]));
          return;
        } else {
          const list = listSelected;
          list.unshift(item);
          setListSelected([...list]);
          dispatch(setValuesMultipleSelectOrderFrom([...list]));
          return;
        }
      }
    },
    [dispatch, globalErrors, listData, listSelected, totalData]
  );

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className="value-mss"
        onClick={togglerDropdownContent}
        ref={btnDropdownRef}
      >
        {isAllDepot ? (
          <span className="list-value-mss">All Order From</span>
        ) : isCheckedSelectAll === false && listSelected.length !== 0 ? (
          listSelected.map((item, index) => (
            <span key={index} className="list-value-mss">
              {item?.name}
            </span>
          ))
        ) : (
          <span className="placeholder-mss">Select Order From</span>
        )}
      </button>
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="overflow-auto max-h-[300px]">
          {listData?.map((el, index) => (
            <div
              key={index}
              className={"dropdown-dds-item truncate"}
              onClick={() => handleClickSelectData(el)}
            >
              <div className="w-full flex justify-between px-2">
                <span>{el?.name}</span>
                <Checkbox checked={isCheckedPerItem(el)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MultipleSelectOrderFrom;
